<template>
  <v-card>
    <v-card-title> Will location </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" lg="6">
          <h4>Will location:</h4>
          <p>
            {{ testator.willLocation ? testator.willLocation : 'Not set' }}
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <h4>Person for Executor to contact to get possession of will:</h4>
          <div v-if="relations.willLocationContact.id">
            <p>
              {{ relations.willLocationContact.fullName }} -
              {{ formatPersonKinship(relations.willLocationContact.kinship) }}
            </p>
            <p>
              Email:
              {{
                relations.willLocationContact.email
                  ? relations.willLocationContact.email
                  : 'Not set'
              }}
            </p>
            <p>
              Cell number:
              {{
                relations.willLocationContact.contactNumber
                  ? relations.willLocationContact.contactNumber
                  : 'Not set'
              }}
            </p>
          </div>
          <p v-else>Not set</p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import { formatKinship } from '../../../constants/js/people';

  export default {
    name: 'WillLocationCard',
    props: {
      testator: {
        required: true,
        type: Object,
      },
      relations: {
        required: true,
        type: Object,
      },
    },
    methods: {
      formatPersonKinship(kinship) {
        return formatKinship(kinship, this.testator);
      },
    },
  };
</script>
